import React, { useState, useEffect, useContext } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import { API } from '../../../API/API';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { UserContext } from '../../../context/UserContext';
import { useNavigate } from 'react-router-dom';
import ColEdit from '../../../components/ColEdit/ColEdit';

const PersonalInformationReport = (props) => {

    const { userInfo } = useContext(UserContext);
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [gridFilter, setGridFilter] = useState([]);
    const [columns, setColumns] = useState([{
        name: 'Регистрийн дугаар',
        fieldName: 'regno',
        maxWidth: 250,
        onRender: (item) => {
            return (
                <ColEdit onClick={() => onPressEmp(item.empid)}>{item.regno}</ColEdit>
            );
        }
    },
    {
        name: 'Ажилтны нэр',
        fieldName: 'firstname',
        maxWidth: 250
    }, {
        name: 'Эцэг/эх-ийн нэр',
        fieldName: 'lastname',
        maxWidth: 250
    }, {
        name: 'Албан байгууллага',
        fieldName: 'companyname',
        maxWidth: 250
    }, {
        name: 'Дотоод нэгж',
        fieldName: 'departmentname',
        maxWidth: 250
    }, {
        name: 'Ажлын байр',
        fieldName: 'positionname',
        maxWidth: 250
    }, {
        name: 'Улсад ажилласан жил',
        fieldName: 'workedmonth'
    }, {
        name: 'Байгууллагад ажилласан жил',
        fieldName: 'orgworkedmonth'
    }, {
        name: 'Ажлын байранд ажилласан жил',
        fieldName: 'posworkedmonth'
    }, {
        name: 'Хүйс',
        fieldName: 'empgendername'
    }]);


    const [loading, setLoading] = useState(false);

    const getData = async (p_gridfilter) => {
        setLoading(true);
        let tData = [];

        let filtercolumns = [];
        if (p_gridfilter?.length > 0) {
            filtercolumns = p_gridfilter;
        }

        if (props.company) {
            filtercolumns.push({
                "fieldname": "companyid",
                "value": userInfo.companyid
            });
        }

        await API.post('/api/humanresource/report/get_employee_report', filtercolumns).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tData = response.data.retdata;
            }
        });

        setData(tData);
        setOData(tData);
        setLoading(false);
    }

    const onPressEmp = (p_empid) => {
        if (p_empid) {
            navigate('/hrsuite/employee/' + p_empid);
        }
    }


    const getGridFilterData = async () => {
        let tGridFilter = [];
        await API.get('/api/humanresource/report/get_employee_report_filter_data').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data?.retdata?.length > 0) {
                    tGridFilter = response.data.retdata;
                }
            }
        });
        setGridFilter(tGridFilter);
    }

    useEffect(() => {
        getData();
        getGridFilterData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    const onGridFilterChange = async (p_gridfiltervalue) => {
        getData(p_gridfiltervalue);
    }

    return (
        <div>
            <PageHeader
                title='Хувь хүний мэдээлэл'
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                gridFilter={gridFilter}
                dataCount={data.length}
                onGridFilterChange={onGridFilterChange}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default PersonalInformationReport;